import { i18next } from "@/locale";

// Basic Rules
export const requiredRules = () => {
  return [{ required: true, message: i18next.t("rules_message.required") }];
};

// String-Based Rules
export const fileTitleRules = () => {
  return [
    {
      pattern: "^[a-zA-Z0-9 ]+$",
      message: i18next.t("rules_message.file_title_rules"),
    },
  ];
};

export const alphanumericRules = () => {
  return [
    {
      pattern: "^^[a-zA-Z0-9]*$",
      message: i18next.t("rules_message.alphanumeric_rules"),
    },
  ];
};

export const emailRules = () => {
  return [{ type: "email", message: i18next.t("rules_message.email_rules") }];
};

export const passwordRules = () => {
  return [
    { required: true, message: i18next.t("rules_message.password_rules") },
  ];
};

export const confirmPasswordRules = () => {
  return [
    {
      required: true,
      message: i18next.t("rules_message.confirm_password_rules"),
    },
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue("password") === value) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(i18next.t("rules_message.not_matching_passwords"))
        );
      },
    }),
  ];
};

export const urlRules = () => {
  return [{ type: "url", message: i18next.t("rules_message.url_rules") }];
};

export const maxCharactersRules = (maxCharacters) => {
  return [
    {
      max: maxCharacters,
      message: i18next.t("rules_message.max_characters_rules", {
        count: maxCharacters,
      }),
    },
  ];
};

export const minCharactersRules = (minCharacters) => {
  return [
    {
      min: minCharacters,
      message: i18next.t("rules_message.min_characters_rules", {
        count: minCharacters,
      }),
    },
  ];
};

export const phoneRules = () => {
  return [
    {
      pattern: /^[0-9\s-]*$/,
      message: i18next.t("rules_message.phone_rules"),
    },
  ];
};

export const internationalPhoneRules = () => {
  return [
    {
      pattern: /^\+?[0-9\s-]*$/,
      message: i18next.t("rules_message.international_phone_rules"),
    },
  ];
};

// Number-Based Rules
export const numberRules = () => {
  return [
    { pattern: "^^[0-9]*$", message: i18next.t("rules_message.number_rules") },
  ];
};

export const numberAndHyphensRules = () => {
  return [
    {
      pattern: "^^[0-9-]*$",
      message: i18next.t("rules_message.number_and_hyphens_rules"),
    },
  ];
};

export const moneyRules = () => {
  return [
    // eslint-disable-next-line
    {
      pattern: "^[0-9]+(?:.[0-9]{1,2})?$",
      message: i18next.t("rules_message.money_rules"),
    },
  ];
};

export const numberRangeRules = (minValue, maxValue) => {
  return [
    {
      type: "number",
      min: minValue,
      max: maxValue,
      message: i18next.t("rules_message.number_range_rules", {
        minValue: minValue,
        maxValue: maxValue,
      }),
    },
  ];
};

export const nameRules = () => {
  return [
    {
      pattern: /^[A-Za-z\s-]+$/,
      message: i18next.t("rules_message.name_rules"),
    },
  ];
};

export const nicRules = () => {
  return [
    {
      pattern: /^[A-Z0-9]{6,12}$/,
      message: i18next.t("rules_message.nic_rules"),
    },
  ];
};

export const passportRules = () => {
  return [
    {
      pattern: /^[A-Z0-9]{6,9}$/,
      message: i18next.t("rules_message.passport_rules"),
    },
  ];
};

export const passportExpirationRules = () => {
  return [
    {
      validator: (_, value) => {
        if (!value) {
          return Promise.resolve();
        }
        const inputDate = new Date(value);
        const currentDate = new Date();
        if (inputDate > currentDate) {
          return Promise.resolve();
        }
        return Promise.reject(
          new Error(i18next.t("rules_message.passport_expiration_rules"))
        );
      },
    },
  ];
};
